const { logger } = require('@fiverr-private/obs');

const { DEFAULT_LOCALE } = require('../constants');

const translate = (k, locale = DEFAULT_LOCALE) => {
    try {
        return i18n.t(k, { $scope: locale });
    }
    catch (err) {
        logger.error(`Failed to get default value for key ${k}`);
        return false;
    }
};

module.exports = {
    translate
};